<template>
	<div class="main">
		<section class="panel">
			<ul id="dormitoryTypeNav" class="nav nav-tabs" role="tablist">
				<li class="" data-apply-type="N" role="presentation" ref="dormitoryTypeTab" v-if="normalIsOpen">
					<a data-toggle="tab" @click="page = 1; dormitoryType = 'N'; selectionDormitoryType()">一般宿舍</a>
				</li>
				<li class data-apply-type="V" role="presentation" ref="dormitoryTypeTab" v-if="vacationIsOpen">
					<a data-toggle="tab" @click="page = 1; dormitoryType = 'V'; selectionDormitoryType()">寒暑假宿舍</a>
				</li>
				<li class data-apply-type="S" role="presentation" ref="dormitoryTypeTab" v-if="specialIsOpen">
					<a data-toggle="tab" @click="page = 1; dormitoryType = 'S'; selectionDormitoryType()">特殊原因宿舍</a>
				</li>
				<li v-if="timeSetting">
					<router-link :to="{name:'stay.timeSetting'}">設定開放時間</router-link>
				</li>
        <li v-if="isAdmin('stay')">
					<router-link :to="{name:'stay.apply.treaty.edit'}">設定隱私權宣告、管理辦法</router-link>
				</li>
			</ul>
			<section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse in">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-12 ">
								<div class="col-md-4" v-if="dormitoryType == 'N'">
									<label class="col-md-4">學期</label>
									<div class="col-md-8">
										<select v-model="qryParam.smtr" class="form-control">
											<option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4" v-else>
									<label class="col-md-4">學年</label>
									<div class="col-md-8">
										<select v-model="qryParam.smtr" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<label class="col-md-4">系科</label>
									<div class="col-md-8">
										<select v-model="qryParam.deptCode" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="(item, index) in deptList" :key="index" :value="item.commCode">{{item.commValue}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<label class="col-md-4">年級</label>
									<div class="col-md-8">
										<select v-model="qryParam.drade" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="d in 7" :key="d" :value="d">{{d}}年級</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12 ">
								<div class="col-md-4">
									<label class="col-md-4">學生狀態</label>
									<div class="col-md-8">
										<select v-model="qryParam.state" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="(item, index) in stateList" :key="index" :value="item.commCode">{{item.commValue}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<label class="col-md-4">學號</label>
									<div class="col-md-8">
										<input type="text" class="form-control" v-model="qryParam.account" />
									</div>
								</div>
								<div class="col-md-4">
									<label class="col-md-4">姓名</label>
									<div class="col-md-8">
										<input type="text" class="form-control" v-model="qryParam.name" />
									</div>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12 ">
								<div class="col-md-4">
									<label class="col-md-4">身分別</label>
									<div class="col-md-8">
										<select v-model.number="qryParam.stuIdentity" class="form-control">
											<option :value="null">--請選擇--</option>
											<option v-for="(item, index) in identiList" :key="index" :value="item.commCode">{{item.commValue}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<label class="col-md-4">審核狀態</label>
									<div class="col-md-8">
										<select v-model="qryParam.applyStatus" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="(item, index) in apysList" :key="index" :value="item.commCode">{{item.commValue}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4" v-if="applyStatus == 'Y'">
									<label class="col-md-4">正/備取</label>
									<div class="col-md-8">
										<select v-model="qryParam.qualification" class="form-control">
											<option value="">--請選擇--</option>
											<option v-for="(item, index) in qualifList" :key="index" :value="item.commCode">{{item.commValue}}</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 "></div>
							<div class="col-md-4 ">
								<div class="col-xs-5 col-md-4">
									<button type="button" class="btn btn-default btn-block" @click="clearSearchParam()">清除</button>
								</div>
								<div class="col-xs-2 col-md-4"></div>
								<div class="col-xs-5 col-md-4">
									<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
								</div>
							</div>
							<div class="col-md-4 "></div>
						</div>
					</div>
				</div>
			</section>
			<div class="tab-content">
				<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
					<div class="row form-group">
						<div class="col-md-12 text-right form-inline" v-if="sessionData.accountType == 'STU'">
							<a href="javascript:;" @click="gotoView('stay.apply.edit', {dormitoryType:'N', smtr:applySmtr})" class="btn btn-danger" v-if="dormitoryType == 'N' && normalIsOpen">一般宿舍申請表</a>
							<a href="javascript:;" @click="gotoView('stay.apply.edit', {dormitoryType:'V', smtr:nowSyear})" class="btn btn-danger" v-if="dormitoryType == 'V' && vacationIsOpen">寒暑假宿舍申請表</a>
							<a href="javascript:;" @click="gotoView('stay.apply.edit', {dormitoryType:'S', smtr:nowSyear})" class="btn btn-danger" v-if="dormitoryType == 'S' && specialIsOpen">特殊原因宿舍申請表</a>
						</div>
						<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
							<button class="btn s_btn_b hidden-xs" @click="applyChangeAll('Y')">審核通過</button>
							<button class="btn s_btn_g hidden-xs" @click="applyChangeAll('N')">審核不通過</button>
							<button class="btn btn-primary hidden-xs" @click="exportExcel">資料匯出</button>
							<label for="fileV" class="btn btn-primary hidden-xs">資料匯入</label>
							<input id="fileV" ref="fileV" name="file" type="file" value accept=".xls, .xlsx" @change="importExcel($event)" style="display: none" />

							<button class="btn s_btn_b btn-block visible-xs" @click="applyChangeAll('Y')">審核通過</button>
							<button class="btn s_btn_g btn-block visible-xs" @click="applyChangeAll('N')">審核不通過</button>
							<button class="btn btn-primary btn-block visible-xs" @click="exportExcel">資料匯出</button>
							<label for="fileV" class="btn btn-primary btn-block visible-xs">資料匯入</label>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<table class="table table-no-more table-bordered table-striped mb-none" >
								<thead>
									<tr v-if="isAdmin('stay')">
										<th class="text-center" width="5%" >
											<input type="checkbox" id="allCheck" name="allCheck" v-model="isAllCheck" @change="allSelection($event)" />
										</th>
										<th class="text-center" width="10%">學期</th>
										<th class="text-center" width="10%">縣市</th>
										<th class="text-center" width="10%">區域</th>
										<th class="text-center" width="10%">系科年級</th>
										<th class="text-center" width="10%">學號</th>
										<th class="text-center" width="10%">姓名</th>
										<th class="text-center" width="10%">申請日期</th>
										<th class="text-center" width="10%">狀態</th>
										<th class="text-center" width="10%">正/備取</th>
										<th class="text-center" width="5%">順序</th>
									</tr>
									<tr v-if="accountType == 'STU'">
										<th class="text-center" width="5%">修改</th>
										<th class="text-center" width="10%">學期</th>
										<th class="text-center" width="10%">學制</th>
										<th class="text-center" width="20%">系科年級</th>
										<th class="text-center" width="10%">學生狀態</th>
										<th class="text-center" width="10%">學號</th>
										<th class="text-center" width="10%">姓名</th>
										<th class="text-center" width="10%">身分別</th>
										<th class="text-center" width="15%">狀態</th>
									</tr>
								</thead>
								<tbody v-if="isAdmin('stay')">
									<tr v-for="(item, index) in roomApplyList.rows" :key="index">
										<td data-title=""  class="text-center">
											<input v-if="!item.bankBarcode_1" type="checkbox" :id="'checkId_'+index" name="checkId" :value="item" v-model="checkedList" @change="checkEvent(item)" />
											<span v-else>--</span>
										</td>
										<td data-title="學期" class="text-center" >{{item.smtrStr}}</td>
										<td data-title="縣市" class="text-center" v-show="isAdmin('stay')">{{item.mailCityStr}}</td>
										<td data-title="區域" class="text-center" v-show="isAdmin('stay')">{{item.mailAreaStr}}</td>
										<td data-title="系科年級" class="text-center" v-bind:title="item.deptCodeStr">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
										<td data-title="學號" class="text-center">{{item.account}}</td>
										<td data-title="姓名" class="text-center" >
											<a class="btn btn-link" @click="gotoView('stay.apply.view', {dormitoryType: item.dormitoryType,id: item.id, idno: item.idno, account: item.account})">{{item.name}}</a>
										</td>
										<td data-title="申請日期" class="text-center" v-show="isAdmin('stay')">{{item.crDateCht}}</td>
										<td data-title="狀態" class="text-center" >
											<select v-if="!item.bankBarcode_1" :data-aims="'#qualification_'+index" v-model="item.applyStatus" @change="applyChange(item)" class="form-control">
												<option value="A">待審核</option>
												<option value="Y">審核通過</option>
												<option value="N">審核不通過</option>
												<option value="R">退回</option>
											</select>
											<span v-else>{{item.applyStatusStr}}</span>
										</td>
										<td data-title="正/備取" class="text-center" >
											<select v-if="item.applyStatus == 'Y' && !item.bankBarcode_1" :id="'qualification_'+index" @change="applyChange(item)" v-model="item.qualification" class="form-control">
												<option value="">請選擇</option>
												<option value="Q">正取</option>
												<option value="W">備取</option>
											</select>
											<span v-else>{{item.qualificationStr}}</span>
										</td>
										<td data-title="順序" class="text-center">
											{{item.qualificationSort}}
										</td>
									</tr>
								</tbody>
								<tbody v-if="accountType == 'STU'">
									<tr v-for="(item, index) in roomApplyList.rows" :key="index">
										<td data-title="修改"  class="text-center">
											<a v-if="item.applyStatus === 'R'" @click="gotoView('stay.apply.edit', {dormitoryType: item.dormitoryType, id: item.id, idno: item.idno, account: item.account})" class="mb-xs mt-xs mr-xs btn-xs btn-info">
												<i class="fa fa-pencil"></i>
											</a>
											<span v-else>--</span>
										</td>
										<td data-title="學期" class="text-center" >{{item.smtr}}</td>
										<td data-title="學制" class="text-center">{{item.deptSsymStr}}</td>
										<td data-title="系科年級" class="text-center" v-bind:title="item.deptCodeStr">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
										<td data-title="學生狀態" class="text-center">{{item.stateStr}}</td>
										<td data-title="學號" class="text-center">{{item.account}}</td>
										<td data-title="姓名" class="text-center" >{{item.name}}</td>
										<td data-title="身分別" class="text-center">{{item.stuIdentityStr}}</td>
										<td data-title="狀態" class="text-center" >{{item.applyStatusStr}}-{{item.qualificationStr}}-{{item.qualificationSort}}</td>
									</tr>
								</tbody>
							</table>

						</div>
						<div class="col-md-12">
							<div class="text-center" v-if="isAdmin('stay')">
								<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	data() {
		return {
			qryParam:{
				dormitoryType: "N",
				smtr: "",
				name:"",
				account:"",
				applyStatus:"",
				qualification:"",
				deptCode:"",
				drade:"",
				state:"",
				stuIdentity:null
			},
			isAllCheck:false,
			dormitoryType: "N",
			arimId: "",
			normalIsOpen: true,
			vacationIsOpen: true,
			specialIsOpen: true,
			isDefault: true,
			accountType: "",
			roomApplyList: {},
			checkedList: [],
			deptList:[],
			stateList:[],
			identiList:[],
			apysList:[],
			qualifList:[],
			name:"",
			account:"",
			applyStatus:"",
			qualification:"",
			deptCode:"",
			drade:"",
			state:"",
			stuIdentity:"",
			page: 1,
			totalPage: 1,
		};
	},
	beforeCreate(){
		let _this = this;
		const api = "/api/Room/stayInit";
		this.$axios.post(api).then(resp =>{
			_this.deptList = resp.data.data.deptList;
			_this.stateList = resp.data.data.stateList;
			_this.identiList = resp.data.data.identiList;
			_this.apysList = resp.data.data.apysList;
			_this.qualifList = resp.data.data.qualifList;
		});
	},
	mounted() {
		if (this.sessionData == null) {
			this.$router.replace({ path: "/" });
		}else{
			this.accountType = this.sessionData.accountType;
			if(!this.isAdmin('stay')){
				this.itemIsOpening().then(()=>{
					this.navInitEvent();
				});
			}else{
        //套用查詢設定
        const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
        if(storeQryParam != null) {
          this.qryParam = storeQryParam;
          this.dormitoryType = storeQryParam.dormitoryType;
        }
        const storePage = this.getStore(`${this.$route.name}.page`);
        if(storePage != null) {
          this.page = storePage;
        }
				this.navInitEvent();
			}
		}
	},
	methods: {
		async selectionDormitoryType(clearQueryParam = true) {
			if (this.isAdmin('stay')) {
				this.qryParam.dormitoryType = this.dormitoryType;
        if(clearQueryParam) {
          this.qryParam.name = "";
          this.qryParam.account = "";
          this.qryParam.applyStatus = "";
          this.qryParam.qualifList = "";
          this.qryParam.deptCode = "";
          this.qryParam.drade = "";
          this.qryParam.state = "";
          this.qryParam.stuIdentity = null;
          if(this.dormitoryType == "N"){
            this.qryParam.smtr = this.nowSmtr;
          }else {
            this.qryParam.smtr = `${this.nowSyear}`
          }
        } else {
          if(this.dormitoryType == "N" && (this.qryParam.smtr.length != 4)){
            this.qryParam.smtr = this.nowSmtr;
          }else if ((this.dormitoryType == "V" || this.dormitoryType == "S" ) && this.qryParam.smtr.length != 3){
            this.qryParam.smtr = `${this.nowSyear}`
          }
        }
			} else {
				this.qryParam.dormitoryType = this.dormitoryType;
				this.qryParam.account = this.sessionData.account
			}

			this.loadGrid();
		},
		loadGrid(){
			let _this = this;
			const api = "/api/Room/roomApplyList";
			let resp = this.$axios.post(api, JSON.stringify({
				model:this.qryParam,
				page: this.page,
				pageSize: 10,
			})).then(resp =>{
				this.roomApplyList = resp.data.data;
				this.totalPage = this.roomApplyList.total;
				this.page = this.roomApplyList.page;
				this.checkedList = [];
				this.isAllCheck = false;
			});
		},
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.loadGrid();
		},
		clearSearchParam(){
			this.qryParam.smtr= ""; // this.applySmtr;
			this.qryParam.name="";
			this.qryParam.account="";
			this.qryParam.applyStatus="";
			this.qryParam.qualification="";
			this.qryParam.deptCode="";
			this.qryParam.drade="";
			this.qryParam.state="";
			this.qryParam.stuIdentity=null;
      this.removeStore(`${this.$route.name}.qryParam`);
      this.removeStore(`${this.$route.name}.page`);
		},
		importExcel(e) {
			const api = "/api/Room/importRoomApplyExcel";
			let _this = this;
			let excelFile = e.target.files[0];
			let formData = new FormData();
			formData.append("file", excelFile);
			formData.append("dormitoryType",this.dormitoryType);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />" ));
					this.selectionDormitoryType();
				} else {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				}
			});
			e.target.value = "";
		},
		exportExcel() {
			const api = "/api/Room/exportRoomApplyExcel";
			this.qryParam.dormitoryType = this.dormitoryType;
			this.$axios.post( api, JSON.stringify(this.qryParam), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(
					new Blob([resp.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "宿舍申請資料_"+this.customFormatter(new Date(),"YYYYMMDD")+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		applyChange(item) {
			let tmpList = [];
			if (item.applyStatus == "Y" && (item.qualification === "W" || item.qualification === "Q")) {
				tmpList.push(item);
			}else if(item.applyStatus != "Y"){
				item.qualification = "";
				tmpList.push(item);
			}else{
				item.qualification = "";
			}

			if(tmpList.length > 0){
				const api = "/api/Room/applyChange";
				this.$axios.post(api, tmpList).then(resp => {
					if (resp.data.status != "success") {
						bootbox.alert(resp.data.msg);
					}else{
						this.updateGrid(this.page);
					}
				});
			}

		},
		applyChangeAll(applyStatus) {
			for(let i=0; i<this.checkedList.length; i++){
				this.checkedList[i].applyStatus = applyStatus;
				this.checkedList[i].qualification = applyStatus == "Y" ? "Q" : "";
			}
			const api = "/api/Room/applyChange";
			this.$axios.post(api, this.checkedList).then(resp => {
				if (resp.data.status != "success") {
					bootbox.alert(resp.data.msg);
				} else {
					this.checkedList = [];
					this.updateGrid(this.page);
				}
			});
		},
		allSelection(event) {
			this.checkedList = [];
			if(event.target.checked){
				this.checkedList = this.roomApplyList.rows.filter(item => {
					return !item.bankBarcode_1
				});
			}
		},
		checkEvent(item) {
			let tmpList = this.roomApplyList.rows.filter(item => {
				return !item.bankBarcode_1
			});
			if(this.checkedList.length == tmpList.length){
				this.isAllCheck = true;
			}else{
				this.isAllCheck = false;
			}
		},
		async itemIsOpening(){
			const apiSetting = "/api/Common/roomTimeSettingByType/";
			await this.$axios.post(apiSetting).then(resp => {
				for(let i=0; i<resp.data.data.length; i++){
					if(resp.data.data[i].key === "N"){
						this.normalIsOpen = resp.data.data[i].value == "Y";
					}else if(resp.data.data[i].key === "V"){
						this.vacationIsOpen = resp.data.data[i].value == "Y";
            this.dormitoryType = "V";
					}
				}
			});
		},
		navInitEvent(){
      document.querySelector(`[data-apply-type="${this.dormitoryType}"]`).classList.add("active");
			this.selectionDormitoryType(false);
		},
		selectYear(){
			let smtrArray = [];
			for(let y = parseInt(this.applySmtr.substring(0,3)); y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},

	},

	computed: {
		timeSetting() {
			if (this.sessionData == null) {
				return false;
			}
			return this.isAdmin('stay') //&& this.sessionData.authType == "S";
		},

	},
	beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name.startsWith("stay.apply.")) {
      this.setStore(`${this.$route.name}.qryParam`, {
        ...this.qryParam,
        dormitoryType: this.dormitoryType
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }

		this.removeStore(this.$route.name);
		next();
	}
};
</script>

